module.exports = __webpack_public_path__ + "static/media/mypage-02.339ba686.png";